export default ["Blue", "Brown", "Green", "Grey", "Mixed", "Other"];
